<template>
  <div class="login row justify-content-center">
    <div class="col-md-6">
        <b-alert variant="danger" dismissible :show="showDismissableAlert" @dismissed="showDismissableAlert=false">
            {{ alertContents }}
        </b-alert>
        <form v-on:submit.prevent="submit">
            <b-form-fieldset
                label="Användarnamn"
                :state="errors.has('username') ? 'danger' : 'success'"
                :horizontal="true"
                :label-size="3">
                <b-form-input v-model="username" name="username" v-validate:username.initial="'required|alpha_num|min:2'" placeholder="Användarnamn"></b-form-input>
            </b-form-fieldset>
            <b-form-fieldset
                label="Lösenord"
                :state="errors.has('password') ? 'danger' : 'success'"
                :horizontal="true"
                :label-size="3">
                <b-form-input type="password" v-model="password" name="password" v-validate:password.initial="'required|min:6'" placeholder="Lösenord"></b-form-input>
            </b-form-fieldset>
            <b-button
                :block="true"
                variant="primary"
                size="lg"
                type="submit">Logga in</b-button>
        </form>
    </div>
  </div>
</template>

<script>
// import Auth from '@/services/auth'
import { mapActions } from 'vuex'
import router from '@/router'
import timer from '@/utils/timeout'
import bugsnag from '@/bugsnag'

export default {
    name: 'Login',
    data () {
        return {
            username: '',
            password: '',
            showDismissableAlert: false,
            alertContents: 'Fel användarnamn eller lösenord'
        }
    },
    methods: {
        ...mapActions({
            login: 'auth_login',
            loadFriends: 'friend_list',
            loadGroups: 'group_list',
            loadWorkarea: 'workarea_list',
            loadTasks: 'task_list'
        }),
        refresh: function () {
            if (this.$store.state.task.syncing !== true) {
                this.loadTasks({offset: 0})
            }
        },
        submit: function () {
            this.$validator.validateAll().then(() => {
                this.login({ username: this.username, password: this.password }).then(() => {
                    // Fetch all friends
                    this.loadFriends()

                    // Fetch all groups
                    this.loadGroups()

                    // Fetch all workareas
                    this.loadWorkarea()

                    // Start background loader
                    timer.startTimedFunction(this.refresh, 1000 * 30 * 1)

                    // Naviate to the root
                    router.push('/')
                }).catch(error => {
                    bugsnag.notify(JSON.stringify(error))

                    if (error.status === 401) {
                        this.alertContents = 'Fel användarnamn eller lösenord'
                    } else {
                        this.alertContents = 'Något gick fel vid inloggning. Försök igen senare.'
                    }

                    this.showDismissableAlert = true
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue